export function getReturnUrl() {
  const absoluteUrl = window.location.href;
  const relativeUrl = absoluteUrl.replace(window.location.origin, '');
  return relativeUrl;
}
